import axios from "axios";
import { qs } from "url-parse";
import { getApiBaseUrl } from "../tools/scripts/shareHelper";

const axiosConfig = {
  baseURL: getApiBaseUrl(),
  responseType: "json",
  timeout: 1000000,
};

console.log("axiosConfig:", axiosConfig);

const axiosClient = axios.create(axiosConfig);

export const axiosGet = (params) => {
  const { url, token } = params;
  return axiosClient.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/x-www-form-urlencoded",
      "Cache-Control": "no-cache",
      "accept-encoding": "gzip, deflate",
      Connection: "keep-alive",
    },
  });
};

export const axiosPost = (params) => {
  const { url, token, data } = params;
  return axiosClient.post(url, qs.stringify(data), {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/x-www-form-urlencoded",
      "Cache-Control": "no-cache",
      "accept-encoding": "gzip, deflate",
      Connection: "keep-alive",
    },
  });
};

export const axiosPatch = (params) => {
  const { url, token, data } = params;
  return axiosClient.patch(url, JSON.stringify(data), {
    headers: {      
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
      //"accept-encoding": "gzip, deflate",
      "Accept": "*/*",
      //Connection: "keep-alive",
    },
  });
};
